import React, { PropsWithChildren } from "react";
import { ReactComponent as Spinner } from "./../../../images/spinner.svg";

type SpinnerWrapperProps = PropsWithChildren<{
  loading: boolean;
}>;

const SpinnerWrapper: React.FC<SpinnerWrapperProps> = ({ loading, children }) => {
  if (loading) {
    return (
      <div
        style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Spinner />
      </div>
    );
  }
  return <>{children}</>;
};

export default SpinnerWrapper;
